import apiClient from './client';
import { Artikel } from '@/types';

export interface NewsListParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface NewsListResponse {
  data: Artikel[];
  total: number;
  page: number;
  limit: number;
}

export interface MessageResponse {
  message: string;
  url?: string;
  id?: number;
  cover?: string | null;
}

export const newsApi = {
  getAll: async (params: NewsListParams = {}): Promise<NewsListResponse> => {
    const response = await apiClient.get('/api/news', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Artikel> => {
    const response = await apiClient.get(`/api/news/${id}`);
    return response.data;
  },

  create: async (data: Partial<Artikel>): Promise<MessageResponse> => {
    const response = await apiClient.post('/api/news', data);
    return response.data;
  },

  update: async (id: number, data: Partial<Artikel>): Promise<MessageResponse> => {
    const response = await apiClient.put(`/api/news/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<MessageResponse> => {
    const response = await apiClient.delete(`/api/news/${id}`);
    return response.data;
  },

  uploadInlineImage: async (file: File): Promise<MessageResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/api/news/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  uploadCover: async (id: number, file: File): Promise<MessageResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(`/api/news/${id}/cover/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};
